import React, { useEffect } from "react";
import { Alert } from 'react-bootstrap';

interface ServerErrorAlertProps {
    class?: string
}

function ServerErrorAlert(props : ServerErrorAlertProps) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Alert variant="danger" className={props.class}>
            <Alert.Heading>Error Inesperado</Alert.Heading>
            <p>
                Problemas en la comunicación con el servidor, por favor contacte al soporte técnico.
            </p>
        </Alert>
    );
}

export default ServerErrorAlert;